export default function scrollElementIntoViewIfNeeded(
  element: HTMLElement | null
) {
  if (!element) {
    return;
  }

  const observer = new IntersectionObserver(
    ([entry], observer) => {
      // only scroll when the console is not fully visible
      if (!entry.isIntersecting) {
        element.scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
      }

      observer.disconnect();
    },
    { root: null, threshold: 0.9 }
  );

  observer.observe(element);
}
